import { render } from "./AdDocActionButtonsInListOfDocs.vue?vue&type=template&id=80303db2&ts=true"
import script from "./AdDocActionButtonsInListOfDocs.vue?vue&type=script&lang=ts"
export * from "./AdDocActionButtonsInListOfDocs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__